<template>
    <div class="header">
        <div class="header_l">
             <a href="javascript:;" class="logoLink" style="">
                  <img src="../../assets/images/index-logo.png" width="124">
             </a>
        </div>
        <div class="header_r">
            <div class="headr_d1">
              <!--  <side-collapse class="sidecoll"></side-collapse>
                <bread-crumb class="bread"></bread-crumb>-->
                <h2 class="header-title">信用报告电子化系统</h2>
                <div class="user-info">
                  <person-setting></person-setting>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import SideCollapse from '@/components/SideCollapse'
import BreadCrumb from '@/components/BreadCrumd'
import PersonSetting from "./PersonSetting";
export default {
    components:{
        SideCollapse,
        BreadCrumb,
        PersonSetting
    }
}
</script>



// WEBPACK FOOTER //
// src/layout/header/index.vue